import { Injectable, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError } from 'rxjs';
import { Utilisateur } from './utilisateur.model';
import { UtilisateursService } from './utilisateurs.service';
import { ToasterService } from '../../layout/toaster/toaster.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UtilisateursStore {
  // Injected services
  private readonly utilisateursService = inject(UtilisateursService);
  private readonly toasterService = inject(ToasterService);
  private readonly translate = inject(TranslateService);

  // Publicly exposed signals
  readonly utilisateurs = computed(() => this.utilisateursResource.value() as Utilisateur[]);
  readonly isLoading = computed(() => this.utilisateursResource.isLoading());
  readonly error = computed(() => this.utilisateursResource.error());

  // Resource to load users from the API
  private readonly utilisateursResource = rxResource({
    stream: () =>
      this.utilisateursService.getAllUtilisateurs().pipe(
        catchError((error) => {
          queueMicrotask(() => {
            this.toasterService.error(this.translate.instant('UTILISATEURS.LOAD_ERROR'));
          });
          throw error;
        }),
      ),
  });

  // Method to reload users
  reloadUtilisateurs(): void {
    this.utilisateursResource.reload();
  }
}
